// extracted by mini-css-extract-plugin
module.exports = {"ButtonIcon":"_2FYPWdBcU0hS4uh-54Xekw==","FooterContainer":"HcHdtL+HwRVChLkbLVbrdA=="};